import { useRef } from "react";
import PropTypes from "prop-types";
import MaleIcon from "../../assets/icons/Male.svg";
import FemaleIcon from "../../assets/icons/Female.svg";
import styles from "./calculator.module.scss";

const GENDERS = [
  { label: "Male", value: "Male", icon: MaleIcon },
  { label: "Female", value: "Female", icon: FemaleIcon },
];

export default function CalculatorGenderSelector({ value, onChange, error }) {
  const firstBtnRef = useRef(null);

  return (
    <div className={styles.formField}>
      <label className={styles.fieldLabel}>Sex</label>
      <div className={styles.genderGroup}>
        {GENDERS.map((g, i) => (
          <button
            type="button"
            key={g.value}
            id={i === 0 ? "abx-sex" : undefined}
            className={
              value === g.value
                ? `${styles.genderBtn} ${styles.genderBtnActive} ${error ? styles.inputContainerError : ""}`
                : `${styles.genderBtn} ${error ? styles.inputContainerError : ""}`
            }
            onClick={() => onChange(g.value)}
            aria-pressed={value === g.value}
            aria-label={g.label}
            ref={i === 0 ? firstBtnRef : undefined}
          >
            <span>{g.label}</span>
            <img src={g.icon} alt="" className={styles.genderIcon} />
          </button>
        ))}
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}

CalculatorGenderSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};
